
import { SiriusComponentModel } from 'sirius-framework';

export class IdleTimeOutModel extends SiriusComponentModel {
    visible: boolean;
}
